<div class="repeaterContainer">
  @if (!editMode && label && showLabel) {
    <span
      [ngClass]="{ 'inline-text-label': true, 'disabled':disabledFlag }"
      >
      {{label}}
    </span>
  }
  @if (!editMode) {
    <div class="selectPreviewData repeaterPreview" (click)="toggleEditMode()">
      @if (values.length > 0) {
        <ul>
          @for (item of values; track item) {
            <li>
              @if (showFieldsUpdated && item['fieldsUpdated'] && item['fieldsUpdated'].length > 0 && item['fieldsUpdated'][0]) {
                <i class="material-icons notificationsIcon changedNotice">error</i>
              }
              {{item[ fields[0].propertyName ]}}
              @if (fields.length > 1) {
                @if (item[ fields[0].propertyName ] && item[fields[1].propertyName]) {
                  <span> - </span>
                  }{{item[ fields[1].propertyName ]}}
                }
              </li>
            }
          </ul>
        }
        @if (values.length === 0) {
          <span>
            {{buttonText}}
          </span>
        }
      </div>
    }
    @if (editMode) {
      <div>
        <table class="weaveRepeater">
          <!--<thead>
            @for (field of fields; track field) {
              <th>
                {{field.label}}
              </th>
            }
            <th class="editTh"></th>
          </thead>-->
          <tbody>
            @for (value of values; track value; let i = $index) {
              <tr>
                @for (field of fields; track field; let j = $index) {
                  <td>
                    @if (showFieldsUpdated && j == 0 && value['fieldsUpdated'] && value['fieldsUpdated'].length > 0 && value['fieldsUpdated'][0]) {
                      <i class="material-icons notificationsIcon changedNotice">error</i>
                    }
                    @if (field.type === 'text' && field.propertyName) {
                      <app-weave-input
                        [label]="field.label"
                        [data]="value[field.propertyName]"
                        (focusOut)="emitValues(i, field.propertyName, $event)"
                        >
                      ></app-weave-input>
                    }
                    @if (field.type === 'textarea') {
                      <app-weave-textarea
                        [label]="field.label"
                        [disabledFlag]="false"
                        [data]="value[field.propertyName]"
                        (focusOut)="emitValues(i, field.propertyName, $event)"
                        >
                      ></app-weave-textarea>
                    }
                    @if (field.type === 'datepicker') {
                      <app-weave-date-picker
                        [data]="value[field.propertyName] | date: 'M/dd/yyyy'"
                        [label]="field.label"
                        [yearOnly]="false"
                        [onlyEditMode]="true"
                        (focusOut)="updateDate(i, field.propertyName, $event)"
                        (focusIn)="setDatePickerActive(true);"
                        (datePickerClosed)="setDatePickerActive(false)"
                        [type]="2"
                        >
                      </app-weave-date-picker>
                    }
                    @if (field.type === 'select') {
                      <app-weave-select
                        [label]="field.label"
                        [data]="value[field.propertyName]"
                        [options]="field.selectValues"
                        (focusOut)="emitValues(i, field.propertyName, $event)"
                        >
                      ></app-weave-select>
                    }
                  </td>
                }
                <td class="repeaterFunctions">
                  <button mat-button [matMenuTriggerFor]="functionsMenu">
                    <i class="material-icons">more_vert</i>
                  </button>
                  <mat-menu #functionsMenu="matMenu" xPosition="before" class="functionsMenu">
                    <button class="buttonWithIcon" mat-fab extended mat-menu-item (click)="removeRow(i)">
                      <mat-icon>delete</mat-icon>
                      Remove Row
                    </button>
                  </mat-menu>
                </td>
              </tr>
            }
          </tbody>
        </table>
        <button class="plusButton plusButton_dark" (click)="addRow()">Add Row</button>
      </div>
    }
  </div>
